module.exports = __webpack_public_path__ + "static/gallery-4-6dc7b0e2e1465ce62e4320060431ccfa.jpg";